import { withInstall, withNoopInstall } from '@bigin/utils'

import Select from './src/select.vue'
import Option from './src/option.vue'
import OptionGroup from './src/option-group.vue'

export const BSelect = withInstall(Select, {
  Option,
  OptionGroup,
})
export default BSelect
export const BOption = withNoopInstall(Option)
export const BOptionGroup = withNoopInstall(OptionGroup)

export * from './src/token'
